module.exports = __webpack_public_path__ + "static/media/Camera26.97c9ff01.jpg";